import { useQuery } from 'react-query'
import settings from '../../components/settings'

const useAppointment = (id) =>
  useQuery(
    id && ['appointment', id],
    () =>
      fetch(
        `${settings.badaAppointmentApiUrl}/appointment/${id}/?brand=${settings.brand}`
      ).then((res) => res.json()),
    { retry: 2 }
  )

export default useAppointment
